import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetAllSupplierApi,
  GetExpenseApi,
  GetExpenseByIdApi,
} from "../../ApiRequests";

// Get user data with null checks
const userData = JSON.parse(localStorage.getItem("user")) || {};
const { branchId = "", role = 1 } = userData;

export const fetchExpenses = createAsyncThunk("fetch/Expenses", async () => {
  try {
    let response;
    if (role === 2) {
      response = await GetExpenseByIdApi(branchId);
    } else {
      response = await GetExpenseApi();
    }
    console.log(response?.data?.data);
    return response?.data?.data.payload;
  } catch (error) {
    console.log(error);
  }
  return [];
});
// export const  = createAsyncThunk("fetch-items", async () => {});

const ExpenseSlice = createSlice({
  name: "expenses",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchExpenses.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchExpenses.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchExpenses.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default ExpenseSlice.reducer;
